import React, {useState} from 'react';
import {Modal, Button, Table, Spin, message, Tag} from 'antd';
import {useDispatch, useSelector} from "react-redux";
import {getExecutionHistoryThunk} from "../Feature/JobSchedulingSlice";

const ExecutionHistoryModal = ({spaceId, jobType, jobName}) => {
    const dispatch = useDispatch();
    const {executionHistories} = useSelector((state) => state.jobScheduling);
    const [isVisible, setIsVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const pageSize = 20;

    const executions = executionHistories[jobType] || [];

    const showModal = async () => {
        setIsVisible(true);
        setCurrentPage(1);
        setLoading(true);
        try {
            await dispatch(getExecutionHistoryThunk({
                spaceId,
                jobType,
                limit: pageSize,
                offset: 0
            }));
            setTotalItems(pageSize * 2); // Assume at least 2 pages to enable pagination
        } catch (error) {
            message.error('Failed to load execution history');
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = async (page) => {
        setCurrentPage(page);
        setLoading(true);
        try {
            const offset = (page - 1) * pageSize;
            await dispatch(getExecutionHistoryThunk({
                spaceId,
                jobType,
                limit: pageSize,
                offset
            }));
        } catch (error) {
            message.error('Failed to load execution history');
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'SUCCESS':
                return 'green';
            case 'FAILED':
                return 'red';
            case 'RUNNING':
                return 'blue';
            default:
                return 'default';
        }
    };

    const columns = [
        {
            title: 'Start Time',
            dataIndex: 'started_at',
            key: 'started_at',
            render: (text) => new Date(text).toLocaleString(),
            sorter: false,
            width: '20%'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => <Tag color={getStatusColor(status)}>{status}</Tag>,
            width: '10%'
        },
        {
            title: 'Duration (ms)',
            dataIndex: 'duration',
            key: 'duration',
            render: (duration) => duration !== null ? duration : 'Running',
            width: '12%'
        },
        {
            title: 'Completed At',
            dataIndex: 'completed_at',
            key: 'completed_at',
            render: (text) => text ? new Date(text).toLocaleString() : 'Not completed',
            width: '20%'
        },
        {
            title: 'Error Message',
            dataIndex: 'error_message',
            key: 'error_message',
            render: (text) => text ? <span style={{color: 'red', fontSize: '12px'}}>{text}</span> : '-',
            width: '38%'
        }
    ];

    return (
        <>
            <Button onClick={showModal} type="link">
                View Execution History
            </Button>

            <Modal
                title={`Execution History - ${jobName}`}
                open={isVisible}
                onCancel={() => setIsVisible(false)}
                width={1200}
                footer={null}
            >
                <Spin spinning={loading}>
                    <Table
                        columns={columns}
                        dataSource={executions.map((exec, idx) => ({...exec, key: exec.id}))}
                        pagination={{
                            current: currentPage,
                            pageSize,
                            total: totalItems,
                            onChange: handlePageChange,
                            showSizeChanger: false
                        }}
                        scroll={{x: 1000}}
                    />
                </Spin>
            </Modal>
        </>
    );
};

export default ExecutionHistoryModal;
